import { render, staticRenderFns } from "./UserReport.vue?vue&type=template&id=362c5d8f"
import script from "./UserReport.vue?vue&type=script&lang=js"
export * from "./UserReport.vue?vue&type=script&lang=js"
import style0 from "./UserReport.vue?vue&type=style&index=0&id=362c5d8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports